import ProductMaterialMixtureCategorySelector from './ProductMaterialMixtureCategorySelector.vue'

export default ProductMaterialMixtureCategorySelector
